import { ReactNode } from 'react';
import type { MessageDescriptor } from 'react-intl';

import Config from '../../../config';

// @ts-ignore
import edokladyShadow from '../../../../static/images/shadows/square_shadow_edoklady.gif';
// @ts-ignore
import boxnowShadow from '../../../../static/images/shadows/square_shadow_boxnow.gif';
// @ts-ignore
import jtbShadow from '../../../../static/images/shadows/small_rectangle_shadow_jtb.gif';
// @ts-ignore
import ivysilaniShadow from '../../../../static/images/shadows/small_rectangle_shadow_ivysilani.gif';
// @ts-ignore
import wwfShadow from '../../../../static/images/shadows/long_rectangle_shadow_wwf.gif';
// @ts-ignore
import kviffShadow from '../../../../static/images/shadows/big_square_shadow_kviff.gif';
// @ts-ignore
import voyoShadow from '../../../../static/images/shadows/vertical_rectangle_shadow_voyo.gif';

export type LangType = 'en' | 'cs' | 'de';

export type ReferenceItemType = {
    title: MessageDescriptor['id'];
    description: MessageDescriptor['id'];
    imgTitle: MessageDescriptor['id'];
    image: string;
    link: string;
    imagePixelated?: string;
    overlayColor?: string;
    shadow?: ReadonlyArray<({ color }: { color?: string }) => ReactNode>;
    caseId: string;
    profilePic: string;
    hideProfile?: boolean;
};

export type HomePageReferencesType = Record<LangType, ReadonlyArray<Partial<ReferenceItemType>>>;

export const homePageReferences = {
    cs: [
        {
            title: 'case.jtbanka.hero.project',
            description: 'case.jtbanka.hero.title',
            imgTitle: 'case.jtbanka.hero.project',
            image: 'references/items/jtb_web_thumbnail.png',
            imagePixelated: 'references/items/jtb_web_thumbnail_hover.jpg',
            link: Config.routes.references.jtbanka,
            overlayColor: 'hsla(174, 100%, 18%, 0.8)',
            shadow: jtbShadow,
            caseId: 'jtbanka',
            hideProfile: true,
            profilePic: '',
        },
        {
            title: 'case.edoklady.hero.project',
            description: 'case.edoklady.hero.title',
            imgTitle: 'case.edoklady.hero.title',
            image: 'references/items/edoklady_web_thumbnail.jpg',
            imagePixelated: 'references/items/edoklady_web_thumbnail_hover.png',
            link: Config.routes.references.edoklady,
            overlayColor: 'hsla(209, 100%, 88%, 0.8)',
            shadow: edokladyShadow,
            caseId: 'edoklady',
            hideProfile: true,
            profilePic: '',
        },
        {
            title: 'references.wwf.title',
            description: 'references.wwf.description',
            imgTitle: 'references.wwf.title',
            image: 'references/items/wwf_web_thumbnail.png',
            imagePixelated: 'references/items/wwf_web_thumbnail_hover.png',
            link: Config.routes.references.wwf,
            overlayColor: 'rgba(99,168,185, 0.78)',
            shadow: wwfShadow,
            caseId: 'wwf',
            profilePic: 'references/case-studies/homepage/wwf.jpg',
        },
        {
            title: 'case.iVysilani.hero.project',
            description: 'case.iVysilani.hero.title',
            imgTitle: 'case.iVysilani.hero.project',
            image: 'references/items/ivysilani_web_thumbnail.png',
            imagePixelated: 'references/items/ivysilani_web_thumbnail_hover.png',
            link: Config.routes.references.ivysilani,
            overlayColor: 'rgba(0, 27, 50, 0.6)',
            shadow: ivysilaniShadow,
            caseId: 'iVysilani',
            hideProfile: true,
            profilePic: 'references/case-studies/homepage/iVysilani.jpg',
        },
        {
            title: 'references.cme.title',
            description: 'references.cme.description',
            imgTitle: 'references.cme.title',
            image: 'references/items/voyo_web_thumbnail.png',
            imagePixelated: 'references/items/voyo_web_thumbnail_hover.png',
            link: Config.routes.references.cme,
            overlayColor: 'rgba(105, 0, 238, 0.65)',
            shadow: voyoShadow,
            caseId: 'nova',
            profilePic: 'references/case-studies/homepage/nova.jpg',
        },
    ],
    en: [
        {
            title: 'case.iVysilani.hero.project',
            description: 'case.iVysilani.hero.title',
            imgTitle: 'case.iVysilani.hero.project',
            image: 'references/items/ivysilani_web_thumbnail.png',
            imagePixelated: 'references/items/ivysilani_web_thumbnail_hover.png',
            link: Config.routes.references.ivysilani,
            overlayColor: 'rgba(0, 27, 50, 0.6)',
            shadow: ivysilaniShadow,
            caseId: 'iVysilani',
            hideProfile: true,
            profilePic: 'references/case-studies/homepage/iVysilani.jpg',
        },
        {
            title: 'case.boxnow.hero.project',
            description: 'case.boxnow.hero.title',
            imgTitle: 'case.boxnow.hero.title',
            image: 'references/items/boxnow_web_thumbnail.png',
            imagePixelated: 'references/items/boxnow_web_thumbnail_hover.png',
            link: Config.routes.references.boxNow,
            overlayColor: 'rgba(79, 185, 30, 0.78)',
            shadow: boxnowShadow,
            caseId: 'boxnow',
            profilePic: 'references/case-studies/homepage/boxnow.jpg',
        },
        {
            title: 'references.wwf.title',
            description: 'references.wwf.description',
            imgTitle: 'references.wwf.title',
            image: 'references/items/wwf_web_thumbnail.png',
            imagePixelated: 'references/items/wwf_web_thumbnail_hover.png',
            link: Config.routes.references.wwf,
            overlayColor: 'rgba(99,168,185, 0.78)',
            shadow: wwfShadow,
            caseId: 'wwf',
            profilePic: 'references/case-studies/homepage/wwf.jpg',
        },
        {
            title: 'references.kviff.title',
            description: 'references.kviff.description',
            imgTitle: 'references.kviff.title',
            image: 'references/items/kviff_web_thumbnail.png',
            imagePixelated: 'references/items/kviff_web_thumbnail_hover.png',
            link: Config.routes.references.kviff,
            overlayColor: 'rgba(40, 42, 44, 0.78)',
            shadow: kviffShadow,
            caseId: 'kviff',
            hideProfile: true,
            profilePic: 'references/case-studies/homepage/kviff.jpg',
        },
        {
            title: 'references.cme.title',
            description: 'references.cme.description',
            imgTitle: 'references.cme.title',
            image: 'references/items/voyo_web_thumbnail.png',
            imagePixelated: 'references/items/voyo_web_thumbnail_hover.png',
            link: Config.routes.references.cme,
            overlayColor: 'rgba(105, 0, 238, 0.65)',
            shadow: voyoShadow,
            caseId: 'nova',
            profilePic: 'references/case-studies/homepage/nova.jpg',
        },
    ],
    de: [
        {
            title: 'references.bundestag.title',
            description: 'references.bundestag.description',
            imgTitle: 'references.bundestag.title',
            image: 'references/items/bundestag.jpg',
            imagePixelated: 'references/items/bundestag.jpg',
            link: Config.routes.references.bundestag,
            overlayColor: 'rgba(247,247,247, 0.78)',
            shadow: jtbShadow,
            caseId: 'bundestag',
            hideProfile: true,
        },
        {
            title: 'references.shipmonk.title',
            description: 'references.shipmonk.description',
            imgTitle: 'references.shipmonk.title',
            image: 'references/items/shipmonk.png',
            imagePixelated: 'references/items/shipmonk.png',
            link: Config.routes.references.shipmonk,
            overlayColor: 'rgba(0,177,72, 0.78)',
            shadow: boxnowShadow,
            caseId: 'shipmonk',
            hideProfile: true,
        },
        {
            title: 'references.wwf.title',
            description: 'references.wwf.description',
            imgTitle: 'references.wwf.title',
            image: 'references/items/wwf_web_thumbnail.png',
            imagePixelated: 'references/items/wwf_web_thumbnail_hover.png',
            link: Config.routes.references.wwf,
            overlayColor: 'rgba(99,168,185, 0.78)',
            shadow: wwfShadow,
            caseId: 'wwf',
            profilePic: 'references/case-studies/homepage/wwf.jpg',
        },
        {
            title: 'references.weshare.title',
            description: 'references.weshare.description',
            imgTitle: 'references.wwf.title',
            image: 'references/items/weshare.jpg',
            imagePixelated: 'references/items/weshare.jpg',
            link: Config.routes.references.weshare,
            overlayColor: 'rgba(247,247,247, 0.78)',
            shadow: jtbShadow,
            caseId: 'weshare',
            hideProfile: true,
        },
        {
            title: 'references.simplifa.title',
            description: 'references.simplifa.description',
            imgTitle: 'references.simplifa.title',
            image: 'references/items/simplifa.jpg',
            imagePixelated: 'references/items/simplifa.jpg',
            link: Config.routes.references.simplifa,
            overlayColor: 'rgba(118,79,165, 0.78)',
            shadow: boxnowShadow,
            caseId: 'simplifa',
            hideProfile: true,
        },
    ],
} as const satisfies HomePageReferencesType;
